import React from "react"

export const SubmenuSpacer = () => {
  return <div className="my-auto has-text-white">|</div>
}
